// ie 브라우저 호환성 관련 polyfill 추가
import '@babel/polyfill/dist/polyfill.min';
import Vue from 'vue';
import axios from 'axios';
import Bootstrap from 'bootstrap-vue';
import moment from 'moment-timezone';
import VueMomentJs from 'vue-momentjs';
import jQuery from 'jquery';
import Popper from 'popper.js';
// import Fragment from 'vue-fragment';
import VTooltip from 'v-tooltip';
import _ from 'lodash';
import { i18n } from './i18n';
import SDLUtil from '@/utils/SDLUtil';
import COAUtil from '@/utils/COAUtil';
import SdlControl from './components/common/control';
import SdlFilters from './filters';
import SdlDirectives from './directives';
import 'bootstrap/dist/js/bootstrap.min';
import App from './App';
import { addEntryPoint, router } from './router';
import store from './vuex/store';
// import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
// import '../static/css/custom.css';
import '../static/css/sdl.css';
import '../static/css/simple-line-icons.css';
import '../static/css/vue-tabs.css';
import api from './service';
import VueToast from './toast';
import loginService from '@/service/loginService';
import { syslinkService } from '@/service';
import LoginExtensionPopup from '@/components/common/popup/LoginExtensionPopup.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

// third party libraries used in bootstrap
global.jQuery = jQuery;
global.$ = jQuery;
global.Popper = Popper;

Vue.use(VueMomentJs, moment);
Vue.use(VTooltip);
Vue.use(VueToast);
Vue.use(DatePicker);
// Vue.use(Fragment.Plugin);

Vue.use(SdlControl); // Additional components. common sdl
Vue.use(SdlFilters); // Additional filters. common sdl
Vue.use(SdlDirectives); // Additional directives. common sdl

// Additional context
Vue.prototype.$CONTEXT = SDLUtil.WEB_CONTEXT_PATH;
Vue.prototype.$context = SDLUtil.WEB_CONTEXT_PATH;
Vue.prototype.$eventBus = new Vue();

Vue.config.productionTip = false;
axios.defaults.headers.common['x-auth-token'] = localStorage.getItem('userToken');
axios.defaults.headers.common['x-auth-refresh-token'] = localStorage.getItem('refreshToken');
if (localStorage.getItem('adminToken') !== null && localStorage.getItem('adminToken') !== '') {
  axios.defaults.headers.common['original-user-id'] = SDLUtil.parseJwt(localStorage.getItem('adminToken')).userId;
}
// ie, edge https://stackoverflow.com/a/45835054
axios.defaults.headers.common.Pragma = 'no-cache';

axios.interceptors.request.use(
  config => {
    axios.defaults.headers.common['x-auth-token'] = localStorage.getItem('userToken');
    axios.defaults.headers.common['x-auth-refresh-token'] = localStorage.getItem('refreshToken');
    axios.defaults.headers.common['last-access-time'] = localStorage.getItem('lastAccessTime');
    // console.log('request:', localStorage.getItem('lastAccessTime'));
    // Do something before request is sent
    if (Object.prototype.hasOwnProperty.call(config, 'data')) {
      if (Object.prototype.hasOwnProperty.call(config.data, 'labelJson')) {
        config.data.labelJson = JSON.stringify(config.data.labelJson);
      }
    }
    return config;
  },
  error => Promise.reject(error),
);

axios.interceptors.response.use(
  response => {
    if (response.headers['x-auth-token']) {
      axios.defaults.headers.common['x-auth-token'] = response.headers['x-auth-token'];
      loginService.setToken(response.headers['x-auth-token']);
    }
    if (response.headers['x-system-admin']) {
      const sa = response.headers['x-system-admin'] === 'true';
      SDLUtil.setSystemAdmin(sa);
    }

    if (response.headers.date !== null && response.headers.date !== '') {
      localStorage.setItem('lastAccessTime', new Date(response.headers.date).getTime());
    }

    if (Object.prototype.hasOwnProperty.call(response.data, 'error')) {
      /*
       * Add code number below if error message is passed to login after error message during certain error code
       */
      const preDefinedErrCodes = ['187', '190', '191', '192', '193', '194', '195', '198', '199', '200', '400', '403', '404', '500', '503', '599'];
      const errorCode = String(response.data.error.code);
      if (
        preDefinedErrCodes.includes(errorCode) &&
        router.currentRoute.fullPath.indexOf('/login') === -1
      ) {
        if (router.currentRoute.path === '/logout') return;
        if (errorCode === '198') router.push(`${SDLUtil.WEB_CONTEXT_PATH}/logout`);
        if (errorCode === '599') {
          router.push(`${SDLUtil.WEB_CONTEXT_PATH}/maintenance`);
          return Promise.resolve();
        }
        if (!(errorCode === '500'
          || errorCode === '403')) {
          api.logout(errorCode)
            .then(() => {
              let loginUrl = `${SDLUtil.WEB_CONTEXT_PATH}/login`;

              const { pathname, search } = document.location;
              if (pathname === '/sysLinkLogin') { // 타 시스템을 통해 접속한 사용자의 SCOP Refresh 토큰 만료시 redirect 세팅
                loginUrl += `?redirect=${pathname + search}`;
              }

              document.location = loginUrl;
            });
        } else {
          const params = {
            code: response.data.error.code,
            errorType: response.data.error.exception,
            redirect: router.currentRoute.fullPath,
          };
          if (process.env.NODE_ENV !== 'prod') params.msg = response.data.error.message;
          router.push({path: `${SDLUtil.WEB_CONTEXT_PATH}/warning`, query: params });
        }
      }
      if (_.isEqual(response.data.error.type, 'CoaException')) {
        const e = response.data.error;
        const cspType = _.isEmpty(e.cspType) ? '' : `[${e.cspType}] `;
        const reason = _.isEmpty(e.reason) ? '' : `<br><br>${cspType}${e.reason}`;

        e.reason = e.message + reason;
        e.message = e.reason;
      }
      return Promise.reject(Object.assign(response, new Error(response.data.error.message)));
    }
    return response;
  },
  error => {
    Promise.reject(error);
  },
);

// axios.get('/static/dummy/allMenuPagePaths.json')
axios
  .get(`${SDLUtil.API_URL}/auth/noauth/all-menu-page-paths`)
  .then(({ data }) => {
    addEntryPoint(data).then(() => {
      new Vue({
        router,
        store,
        i18n,
        render: h => h(App),
      }).$mount('#app');
    });
  })
  .catch(err => {
    // TODO network error processing
    console.error(err);
    // alert(err);
    window.location = `${SDLUtil.WEB_CONTEXT_PATH}/static/error.html`;
  });
let checkedRefreshToken = '';
setInterval(
  () => {
    if (SDLUtil.isLogin()) {
      const refreshToken = localStorage.getItem('refreshToken');
      if (refreshToken) {
        const refreshUser = SDLUtil.parseJwt(refreshToken);
        if (refreshUser.exp) {
          const refreshExp = refreshUser.exp * 1000;
          const now = Date.now();
          if ((refreshExp - now) <= (10 * 60 * 1000) && (refreshExp - now) > 0) {
            if (refreshToken !== checkedRefreshToken) {
              checkedRefreshToken = refreshToken;
              const msg = `SCOP Login expired at ${moment(refreshExp).format('yyyy-MM-DD hh:mm')}`;
              SDLUtil.show(LoginExtensionPopup, {}, { sizeClass: 'small' });
              Notification.requestPermission().then((permission) => {
                if (permission === 'granted') {
                  const notification = new Notification('SCOP', { body: msg, icon: `${process.env.FRONT_URL}/static/image/common/logo_scop.svg`, requireInteraction: true });
                  notification.addEventListener('click', () => {
                    window.focus();
                    notification.close();
                  });
                }
              });
            }
          }
          if ((refreshExp - now) <= 0 && router.currentRoute.path !== '/logout') router.push(`${SDLUtil.WEB_CONTEXT_PATH}/logout`);
        }
      }
    }
  },
  10000,
);
Notification.requestPermission().then(r => console.log(r));



// WEBPACK FOOTER //
// ./src/main.js